__webpack_require__.p = "//lesson-homework-micro-front.kimitsu.it-incubator.io/";